module.exports = __webpack_public_path__ + "media/images/photo/plans/places/hisaya_odori_park-0ac1f7ca82de7202445a5456c9fe8b8e.png";